<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-form-reporte-Contrato"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar reporte de contratos</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="id_nomina" class="col-md-5">Empresa</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="form.empresa"
                      placeholder="Empresas"
                      label="razon_social"
                      class="form-control p-0"
                      :options="listasForms.empresas"
                      @input="selectEmpresa()"
                    ></v-select>
                    <label class="col-md-5">Bloque</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="form.bloque"
                      placeholder="Bloque"
                      label="nombre"
                      :options="listasForms.bloques"
                      class="form-control p-0"
                      @input="selectBloque()"
                    ></v-select>
                    <label for="id_nomina" class="col-md-5"
                      >Fecha inicial</label
                    >
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="form.fecha_ini"
                    />
                    <label for="id_nomina" class="col-md-5">Fecha final</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="form.fecha_fin"
                    />
                    <label for="id_nomina" class="col-md-5">Valor</label>
                    <input
                      type="num"
                      class="form-control form-control-sm"
                      v-model="form.valor"
                    />
                    <label for="id_nomina" class="col-md-5"
                      >Vigencia póliza</label
                    >
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="form.vigenciaPoliza"
                    />
                    <label for="id_nomina" class="col-md-5">Estado</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="form.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estados in listasForms.estado"
                        :key="estados.numeracion"
                        :value="estados.numeracion"
                      >
                        {{ estados.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";
export default {
  name: "PlantContratoExport",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      form: {
        empresa: null,
        empresa_id: null,
        fecha_ini: null,
        fecha_fin: null,
        bloque: null,
        bloque_id: null,
        valor: null,
        vigenciaPoliza: null,
        estado: null,
      },
      listasForms: {
        empresas: [],
        bloque: [],
        estado: [],
      },
    };
  },

  methods: {
    getEmpresas() {
      axios
        .get("/api/admin/empresas/lista", {
          // params: {
          //   linea_negocio_id: [5],
          // },
        })
        .then((response) => {
          this.listasForms.empresas = response.data;
        });
    },

    selectEmpresa() {
      this.form.empresa_id = this.form.empresa.id;
    },

    getBloques() {
      axios.get("/api/plant/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    selectBloque() {
      this.form.bloque_id = this.form.bloque.id;
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estado = response.data;
      });
    },

    generarListadoExcel() {
      axios({
        method: "POST",
        url: "/api/plant/contratos/reporte",
        data: this.form,
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: e.response?.data?.message || "Ocurrió un error al generar el reporte.",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    this.getBloques();
    this.getEmpresas();
    this.getEstados();
    this.cargando = false;
  },
};
</script>
